import React from "react";

import FooterNavigationEssential from "@containers/builderSectionModels/FooternavigationEssential";
import FooterNavigationMain from "@containers/builderSectionModels/FooterNavigationMain";

type DefaultFooterType = {
  pathname: string;
};

const DefaultFooter: React.FC<DefaultFooterType> = ({ pathname }) => (
  <>
    <FooterNavigationMain pathname={pathname} />
    <FooterNavigationEssential pathname={pathname} />
  </>
);

export default DefaultFooter;
